import $ from "jquery";

export default function () {
    /**
     * Modal loading
     */
    if (document.querySelector('#loadingModal')) {
        document.querySelector('#loadingModal').addEventListener('shown.bs.modal', () => {
            console.log('modal loading aperto');
        })
    }

    if (document.querySelector('#warningModal')) {
        $("#warningModal").find('[data-source]').hide();
        document.querySelector('#warningModal').addEventListener('show.bs.modal', (e) => {
            $(e.target).find("[data-source='" + $(e.relatedTarget).data('modal-source') + "']").show();
        })
        document.querySelector('#warningModal').addEventListener('hidden.bs.modal', (e) => {
            $("#warningModal").find('[data-source]').hide();
        })
    }

    $('body').on('change', '.category__input', function () {
        let target;
        switch ($(this).val()) {
            case "2":
            case "3":
            case "4":
                target = "#code12NCModal";
                break;
            case "5":
            case "7":
                target = "#serialNumberModal";
                break;
            case "6":
                target = "#modelModal";
                break;
            default:
                target = "#code12NCModal";
        }
        const $accordionItem = $(this).parents('.accordion-item');
        if ($accordionItem.find('[data-modal-source="fnr"]').length) {
            $accordionItem.find('[data-modal-source="fnr"]').attr('data-bs-target', target);
        }
        if ($accordionItem.find('[data-modal-source="12nc"]').length) {
            $accordionItem.find('[data-modal-source="12nc"]').attr('data-bs-target', target);
        }
        if ($accordionItem.find('[data-modal-source="model"]').length) {
            $accordionItem.find('[data-modal-source="model"]').attr('data-bs-target', target);
        }
    });

    if (document.querySelector('#serialNumberModal')) {
        document.querySelector('#serialNumberModal').addEventListener('show.bs.modal', (e) => {
            const $target = $(e.relatedTarget).parents('.accordion-collapse').find('.category__input:checked');
            $("#serialNumberModal h4").html(modalTexts[$(e.relatedTarget).data("modal-source")].title);
            $("#serialNumberModal .textbody").html(modalTexts[$(e.relatedTarget).data("modal-source")].text);
            $("#serialNumberModal .info-modal__image").attr("src", modalTexts[$(e.relatedTarget).data("modal-source")].images[$target.val()]);
        });
    }

    if (document.querySelector('#code12NCModal')) {
        document.querySelector('#code12NCModal').addEventListener('show.bs.modal', (e) => {
            const $target = $(e.relatedTarget).parents('.accordion-collapse').find('.category__input:checked');
            $("#code12NCModal h4").html(modalTexts[$(e.relatedTarget).data("modal-source")].title);
            $("#code12NCModal .textbody").html(modalTexts[$(e.relatedTarget).data("modal-source")].text);
            $("#code12NCModal .info-modal__image").attr("src", modalTexts[$(e.relatedTarget).data("modal-source")].images[$target.val()]);
        });
    }

    if (document.querySelector('#modelModal')) {
        document.querySelector('#modelModal').addEventListener('show.bs.modal', (e) => {
            const $target = $(e.relatedTarget).parents('.accordion-collapse').find('.category__input:checked');
            $("#modelModal h4").html(modalTexts[$(e.relatedTarget).data("modal-source")].title);
            $("#modelModal .textbody").html(modalTexts[$(e.relatedTarget).data("modal-source")].text);
            $("#modelModal .info-modal__image").attr("src", modalTexts[$(e.relatedTarget).data("modal-source")].images[$target.val()]);
        });
    }
}
